import React from 'react';

function RightSection({imageURL, productName, productDescription , learnMore,}) {
    return ( 
     <div className='container p-5 '>
        <div className='row'>
            <div className='col-6 mt-5 p-5'>
                 <h1>{productName}</h1>
                    <p>{productDescription}</p>
                    <br/>
                    <a href={learnMore} style={{textDecoration:"none"}}>Learn More&nbsp;<i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>
            </div>
            <div className='col-6 p-5'>
                  <img src={imageURL} style={{width:"100%"}} />
            </div>
        </div>
    </div> 
);
}

export default RightSection;